import * as React from 'react'
import { styled } from '@mui/material/styles'

import Backdrop from '@mui/material/Backdrop'
import Toolbar from '@mui/material/Toolbar'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'

import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import DesktopHeader from './components/desktop-header'
import MobileHeader from './components/mobile-header'
import MobileDrawer from './components/mobile-drawer'

export const HeaderBarHeightPixel = 60

const StyledAppBar = styled(AppBar)`
    box-shadow: none;
    background: ${({ theme }) => theme.palette.background.default};
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`

const HeaderBar = () => {
    const [drawerOpen, setDrawerOpen] = React.useState(false)
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false)

    return (
        <>
            <StyledAppBar>
                <ResponsiveContainer maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box width={'100%'}>
                            {/** Desktop */}
                            <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
                                <DesktopHeader drawerOpen={drawerOpen} onDrawerToggle={(open) => setDrawerOpen(open)} />
                            </Box>

                            {/** Mobile */}
                            <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
                                <MobileHeader onOpen={() => setMobileMenuOpen(true)} />
                                <MobileDrawer open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
                            </Box>
                        </Box>
                    </Toolbar>
                </ResponsiveContainer>
            </StyledAppBar>
            <Backdrop
                sx={{ zIndex: (theme) => theme.zIndex.appBar - 1 }}
                open={drawerOpen}
                onClick={() => setDrawerOpen(false)}
            />
        </>
    )
}

export default HeaderBar
